const charts = state => state.charts;
const getCoins = state => state.coins;
const getAllSparkline = state => state.processedSparkLineData;
const getCoinByID= (state) => (id) => {
      return state.processedSparkLineData.find(chart => chart.id === id)
}
    
export default {
    charts,
    getCoins,
    getCoinByID,
    getAllSparkline,
}



// WEBPACK FOOTER //
// ./src/store/getters.js